import React from 'react'
import "./Skills.css"

const Skills = () => {
  return (
    <>
    <div id='skills' className='skills py-4 mb-5 '>
      <h3 className='text-3xl py-2 text-#1281A4'>Skills and Technologies</h3>
      <p>Android Studio, Visual Studio Code, Git,</p>
      <p>Android(Java/Kotlin), Flutter (Dart),</p>
      <p>REST API,s GraphQl, Firebase, Zeplin,</p>
      <p>Trello, Airtable, JIRA, slack</p>
    </div>
    </>
  )
}

export default Skills
